import { useAuth0 } from "@auth0/auth0-react";

export type AspectChoice = "WIDESCREEN" | "VERTICAL";
export type ResolutionChoice = "720p" | "1080p";
export type PersonChoice = "allow_adult" | "dont_allow";

export interface GenerateVideoRequest {
    action: "video";
    prompt: string;
    negative_prompt?: string;
    aspect_ratio?: AspectChoice;
    image_file_id?: string;
    seed?: number;
    video_length?: 4 | 6 | 8;
    video_resolution?: ResolutionChoice;
    generate_audio?: boolean;
    person_generation?: PersonChoice;
    sample_count?: 1 | 2;
    post_crop_to_starter_aspect?: boolean;
}

export function useGenerateMediaAPI() {
    const { getAccessTokenSilently } = useAuth0();
    const API = `${process.env.REACT_APP_API_URL}`;

    const authFetch = async (url: string, init: RequestInit = {}) => {
        const token = await getAccessTokenSilently();
        const res = await fetch(url, {
            ...init,
            headers: {
                ...(init.headers || {}),
                authorization: `Bearer ${token}`,
                ...(init.headers as any)?.["Content-Type"] ? {} : {},
            },
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        return res;
    };

    const generateVideo = async (payload: GenerateVideoRequest) => {
        const res = await authFetch(`${API}/generative-output/generate`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });
        return res.json();
    };

    const getResult = async (taskQueueId: string) => {
        const res = await authFetch(`${API}/generative-output/task/${taskQueueId}`);
        return res.json();
    };

    const saveOutput = async (taskQueueId: string, generativeOutputId?: string) => {
        const url = new URL(`${API}/generative-output/task/${taskQueueId}/save`);
        if (generativeOutputId) url.searchParams.set("generativeOutputId", generativeOutputId);
        await authFetch(url.toString(), { method: "PUT" });
    };

    return { generateVideo, getResult, saveOutput };
}
